export const en = {
    "k_9fbdbc0a": "Whether to allow the data source interface to be called through the \"MCP Proxy\""
};
